export default "__VITE_ASSET__B6J4GnaV__"